import { BonusItems } from '../elements/BonusItems';
import { WildItem } from '../elements/WildItem';

export const ProgressiveBonusSlide_2 = {
	name: 'progressive_bonus_slide_2',
	posisiton: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'slider_bg_title',
			type: 'CustomText',
			text: 'SPLASH_SLIDE_TITLE_1',
			position: { x: 982 / 2 + 10, y: 30 },
			anchor: { x: 0.5, y: 0 }
		},
		{
			name: 'bg',
			type: 'Sprite',
			img: 'is_blurred_bg',
			alpha: 0.8,
			position: {
				x: 75,
				y: 257
			}
		},
		{
			name: 'progressive_bonus',
			position: { x: -40, y: 292 },
			type: 'VisualComponent',
			component: BonusItems
		},
		{
			name: 'progressive_bonus_wild',
			position: { x: 50, y: 270 },
			type: 'VisualComponent',
			component: WildItem
		},
		{
			name: 'progressive_bonus_wild',
			position: { x: 380, y: 330 },
			type: 'VisualComponent',
			component: WildItem
		},
		{
			name: 'progressive_bonus_wild',
			position: { x: 715, y: 400 },
			type: 'VisualComponent',
			component: WildItem
		}
	]
};
